module.exports = __webpack_public_path__ + "img/elite_beige_ba_list.749b8c2b.jpg";